<template>
    <div>
        <a class="btn-annotation btn-play-multipage-block"
           :class="`btn-play-multipage-block-${props.annot.id}`"
           href="#"
           :style="data.styleRect"
           @click.prevent="startMultiBlock"
        >
            <img :src="`${bookInfoState.publicPath}/${props.annot.iconSrc}`"
                 v-if="props.annot.iconSrc"
            >
        </a>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import cssvar from '@/scss/_variables.scss';

    const colorRect = cssvar.colorRect;
    const {getResizedAnnotationPos, styleAnnotationBtn} = useAnnotationHelper();

    export default {
        props: {
          annot:Object,
          sharedMeta:Object
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();
            const { playBlockState, setBlockData, playBlocks} = usePlayBlockControl();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        ...styleAnnotationBtn()
                    }
                }),
                wordAudioData:computed(()=>{
                    return  props.sharedMeta[props.annot.grouptag]["wordAudioData"][bookInfoState.activeSpeech];
                }),
                formattedAudioSrcList:null
            });

            const startMultiBlock = ()=> {

                useKaraokeControl().reset();
                usePlayBlockControl().reset();

                playBlockState.multiWholePageStatus = {
                    btnIdPageMapping: props.annot.btnIdPageMapping, //store a reference of btnIdPageMapping so that the karaoke control knows when to finish.
                    multiPageTargetBtnId: props.annot.btnIdPageMapping[0]["aimPageBtnId"], //which button id of the target page to point to. It must be the first item in the mapping to start with
                    multiPageTargetPageNum: props.annot.btnIdPageMapping[0]["aimPageIndex"], //target page number (zero-based).  It must be the first item in the mapping to start with
                    playedPageCount:0 //store how many pages have finished playing. Compare with the total page count to determine when to complete all.
                };

            }

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
                playBlockState,
                startMultiBlock,
                setBlockData,
                playBlocks,
                getResizedAnnotationPos
            }

        }
    }

 </script>


<style scoped lang="scss">

</style>